// extracted by mini-css-extract-plugin
export var fullScreen = "Section-module--fullScreen--vCU9b";
export var overlayContainer = "Section-module--overlayContainer--2OAc7";
export var sideBySide = "Section-module--sideBySide--1eUSv";
export var content = "Section-module--content--23Lv5";
export var buttonsContainer = "Section-module--buttonsContainer--T2WR2";
export var linkMargin = "Section-module--linkMargin--2YMCG";